const config = {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
  NOME_FANTASIA: "SeCuidaê",
  CNPJ: "35.842.745/0001-82",
  CEP: "22790-022",
  TELEFONE: "(21) 3369-9571",
  WHATSAPP: "(21)97171-7080",
  EMAIL: "atendimento@secuidae.com.br",
  LOGRADOURO: "Avenida das Américas",
  NUMERO: "12900",
  COMPLEMENTO: "Loja SS106",
  BAIRRO: "Barra da Tijuca",
  CIDADE: "Rio de Janeiro",
  ESTADO: "Rio de Janeiro",
  UF: "RJ",
};

export default config;
